import React, { useState } from "react";
import { ToggleTheme } from "./ToggleTheme";
import { LiquidGlass } from "@liquidglass/react";
import { useTitle } from "../utils/useTitle";
import { motion, AnimatePresence } from "motion/react";
import { RxHamburgerMenu } from "react-icons/rx";
import { RxCross1 } from "react-icons/rx";
import { Button } from "@mui/material";

const MotionGlass = motion.create(LiquidGlass);

export const Navbar = () => {
  const { currentTitle, scrollDirection } = useTitle();
  const [isExpanded, setIsExpanded] = useState(false);

  const animations = {
    down: { initial: { y: 20, opacity: 0 }, exit: { y: -20, opacity: 0 } },
    up: { initial: { y: -20, opacity: 0 }, exit: { y: 20, opacity: 0 } },
  };

  const currentAnimation = animations[scrollDirection];

  return (
    <div className="fixed top-0 left-0 right-0 z-20 p-4 flex justify-center items-center font-mono">
      <MotionGlass
        borderRadius={15}
        blur={0.3}
        contrast={1}
        brightness={1.2}
        saturation={1.65}
        layout
        transition={{ type: "spring", stiffness: 120, damping: 18 }}
        className="flex flex-col md:!w-[70%] !w-full overflow-hidden"
      >
        <div className="flex justify-between items-center w-full h-16 p-4">
          <div
            className="text-lg hover-text select-none cursor-pointer"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {!isExpanded ? (
              <RxHamburgerMenu className="text-2xl" />
            ) : (
              <RxCross1 className="text-2xl" />
            )}
          </div>

          <span className="md:w-[15%] w-[40%] text-center md:text-4xl text-xl text-main font-bold select-none">
            Anurag.
            <AnimatePresence mode="popLayout">
              <motion.span
                key={currentTitle}
                initial={currentAnimation.initial}
                animate={{ y: 0, opacity: 1 }}
                exit={currentAnimation.exit}
                transition={{ duration: 0.4, ease: "easeInOut" }}
                className="font-light select-none"
              >
                {currentTitle}
              </motion.span>
            </AnimatePresence>
          </span>

          <ToggleTheme />
        </div>

        {/* Expandable section */}
        <AnimatePresence>
          {isExpanded && (
            <motion.div
              key="menu"
              layout
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 50 }}
              exit={{ opacity: 0, height: 0 }}
              transition={{
                height: { duration: 0.35, ease: [0.4, 0, 0.2, 1] },
                opacity: { duration: 0.25, ease: "easeInOut" },
              }}
              className="flex items-center justify-evenly w-full overflow-hidden"
            >
              <Button
                size="small"
                variant="outlined"
                className="!text-main !border-main"
              >
                Download CV
              </Button>
              
              <Button
                size="small"
                variant="outlined"
                className="!text-main !border-main"
                onClick={() => {
                  window.open(
                    "https://drive.google.com/uc?export=download&id=11-T8Tpv9TXE6KzLrWScXzf-Oe6Bc7R7e",
                    "_blank"
                  );
                }}
              >
                Download CV
              </Button>
            </motion.div>
          )}
        </AnimatePresence>
      </MotionGlass>
    </div>
  );
};
